// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes homeFadeUp {
  from {
    opacity: 0;
    transform: translateY(24px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes homeFloat {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-12px);
  }
}
.homePage .homeProducts {
  padding: clamp(3.5rem, 8vw, 6rem) 0;
  background: #ffffff;
}
.homePage .homeProducts__inner {
  width: min(1120px, 100% - 2.5rem);
  margin-inline: auto;
  width: min(1120px, 100%);
}
.homePage .homeProducts__intro {
  text-align: center;
  margin-bottom: 2rem;
}
.homePage .homeProducts__intro h2 {
  margin: 0 0 0.6rem;
  font-size: clamp(1.7rem, 3vw, 2.3rem);
  font-weight: 700;
}
.homePage .homeProducts__intro p {
  margin: 0;
  color: #5c6578;
  font-size: 1.05rem;
}
.homePage .homeProducts__tabs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
  max-width: 720px;
  margin: 0 auto 2.25rem;
  padding: 0.4rem;
  background: #f4f7fb;
  border-radius: 18px;
  border: 1px solid rgba(26, 31, 44, 0.08);
}
.homePage .homeProducts__tab {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  text-align: left;
  padding: 0.95rem 1rem;
  border: none;
  border-radius: 14px;
  background: transparent;
  color: #5c6578;
  cursor: pointer;
  transition: background 0.25s ease, color 0.25s ease, box-shadow 0.25s ease;
}
.homePage .homeProducts__tab i {
  font-size: 1.25rem;
  color: #3fb9ea;
}
.homePage .homeProducts__tab strong {
  display: block;
  font-family: "Plus Jakarta Sans", system-ui, sans-serif;
  font-size: 1rem;
  color: #1a1f2c;
  font-weight: 600;
}
.homePage .homeProducts__tab small {
  display: block;
  margin-top: 0.15rem;
  font-size: 0.8rem;
  color: #5c6578;
}
.homePage .homeProducts__tab.is-active {
  background: #ffffff;
  box-shadow: 0 8px 24px rgba(26, 31, 44, 0.08);
  color: #1a1f2c;
}
.homePage .homeProducts__tile {
  height: 100%;
  padding: 1.5rem 1.35rem;
  border-radius: 20px;
  border: 1px solid rgba(26, 31, 44, 0.08);
  background: linear-gradient(180deg, #fff 0%, #f8fbfd 100%);
  transition: border-color 0.25s ease, transform 0.25s ease;
}
.homePage .homeProducts__tile:hover {
  border-color: rgba(63, 185, 234, 0.5);
  transform: translateY(-4px);
}
.homePage .homeProducts__tile h3 {
  margin: 0.9rem 0 0.3rem;
  font-size: 1.15rem;
  font-weight: 700;
}
.homePage .homeProducts__tile h4 {
  margin: 0 0 0.65rem;
  font-size: 0.88rem;
  font-weight: 600;
  color: #1a9fd4;
  font-family: "Outfit", system-ui, sans-serif;
  letter-spacing: 0;
}
.homePage .homeProducts__tile p {
  margin: 0;
  color: #5c6578;
  font-size: 0.95rem;
  line-height: 1.55;
}
.homePage .homeProducts__icon {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(63, 185, 234, 0.14);
  color: #1a9fd4;
  font-size: 1.15rem;
}

@media (max-width: 767px) {
  .homePage .homeProducts__tabs {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Home/home-tokens.scss","webpack://./src/Components/Home/Cards/Style.scss"],"names":[],"mappings":"AA2BA;EACE;IACE,UAAA;IACA,2BAAA;EC1BF;ED4BA;IACE,UAAA;IACA,wBAAA;EC1BF;AACF;AD6BA;EACE;IAEE,wBAAA;EC5BF;ED8BA;IACE,4BAAA;EC5BF;AACF;AAfA;EACE,mCAAA;EACA,mBAAA;AAiBF;AAfE;EDMA,iCAAA;EACA,mBAAA;ECLE,wBAAA;AAkBJ;AAfE;EACE,kBAAA;EACA,mBAAA;AAiBJ;AAfI;EACE,kBAAA;EACA,qCAAA;EACA,gBAAA;AAiBN;AAdI;EACE,SAAA;EACA,cDtBO;ECuBP,kBAAA;AAgBN;AAZE;EACE,aAAA;EACA,8BAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,mBDhCQ;ECiCR,mBAAA;EACA,wCAAA;AAcJ;AAXE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,cDhDS;ECiDT,eAAA;EACA,0EAAA;AAaJ;AAXI;EACE,kBAAA;EACA,cDlDM;AC+DZ;AAVI;EACE,cAAA;EACA,uDDpDS;ECqDT,eAAA;EACA,cD9DK;EC+DL,gBAAA;AAYN;AATI;EACE,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,cDrEO;ACgFb;AARI;EACE,mBDtEO;ECuEP,6CAAA;EACA,cD5EK;ACsFX;AANE;EACE,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,wCAAA;EACA,0DAAA;EACA,yDAAA;AAQJ;AANI;EACE,qCAAA;EACA,2BAAA;AAQN;AALI;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;AAON;AAJI;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cDjGW;ECkGX,4CD/FM;ECgGN,iBAAA;AAMN;AAHI;EACE,SAAA;EACA,cD7GO;EC8GP,kBAAA;EACA,iBAAA;AAKN;AADE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,cDtHa;ECuHb,kBAAA;AAGJ;;AACA;EAEI;IACE,0BAAA;EACJ;AACF","sourcesContent":["$home-ink: #1a1f2c;\r\n$home-muted: #5c6578;\r\n$home-line: rgba(26, 31, 44, 0.08);\r\n$home-mist: #f4f7fb;\r\n$home-paper: #ffffff;\r\n$home-teal: #3fb9ea;\r\n$home-teal-deep: #1a9fd4;\r\n$home-red: #d60000;\r\n$home-display: \"Plus Jakarta Sans\", system-ui, sans-serif;\r\n$home-body: \"Outfit\", system-ui, sans-serif;\r\n\r\n@mixin home-container {\r\n  width: min(1120px, calc(100% - 2.5rem));\r\n  margin-inline: auto;\r\n}\r\n\r\n@mixin home-reveal {\r\n  opacity: 0;\r\n  transform: translateY(28px);\r\n  transition: opacity 0.7s ease, transform 0.7s ease;\r\n\r\n  &.is-visible {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes homeFadeUp {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(24px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes homeFloat {\r\n  0%,\r\n  100% {\r\n    transform: translateY(0);\r\n  }\r\n  50% {\r\n    transform: translateY(-12px);\r\n  }\r\n}\r\n","@import \"../home-tokens.scss\";\r\n\r\n.homePage .homeProducts {\r\n  padding: clamp(3.5rem, 8vw, 6rem) 0;\r\n  background: $home-paper;\r\n\r\n  &__inner {\r\n    @include home-container;\r\n    width: min(1120px, 100%);\r\n  }\r\n\r\n  &__intro {\r\n    text-align: center;\r\n    margin-bottom: 2rem;\r\n\r\n    h2 {\r\n      margin: 0 0 0.6rem;\r\n      font-size: clamp(1.7rem, 3vw, 2.3rem);\r\n      font-weight: 700;\r\n    }\r\n\r\n    p {\r\n      margin: 0;\r\n      color: $home-muted;\r\n      font-size: 1.05rem;\r\n    }\r\n  }\r\n\r\n  &__tabs {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 0.75rem;\r\n    max-width: 720px;\r\n    margin: 0 auto 2.25rem;\r\n    padding: 0.4rem;\r\n    background: $home-mist;\r\n    border-radius: 18px;\r\n    border: 1px solid $home-line;\r\n  }\r\n\r\n  &__tab {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.85rem;\r\n    text-align: left;\r\n    padding: 0.95rem 1rem;\r\n    border: none;\r\n    border-radius: 14px;\r\n    background: transparent;\r\n    color: $home-muted;\r\n    cursor: pointer;\r\n    transition: background 0.25s ease, color 0.25s ease, box-shadow 0.25s ease;\r\n\r\n    i {\r\n      font-size: 1.25rem;\r\n      color: $home-teal;\r\n    }\r\n\r\n    strong {\r\n      display: block;\r\n      font-family: $home-display;\r\n      font-size: 1rem;\r\n      color: $home-ink;\r\n      font-weight: 600;\r\n    }\r\n\r\n    small {\r\n      display: block;\r\n      margin-top: 0.15rem;\r\n      font-size: 0.8rem;\r\n      color: $home-muted;\r\n    }\r\n\r\n    &.is-active {\r\n      background: $home-paper;\r\n      box-shadow: 0 8px 24px rgba(26, 31, 44, 0.08);\r\n      color: $home-ink;\r\n    }\r\n  }\r\n\r\n  &__tile {\r\n    height: 100%;\r\n    padding: 1.5rem 1.35rem;\r\n    border-radius: 20px;\r\n    border: 1px solid $home-line;\r\n    background: linear-gradient(180deg, #fff 0%, #f8fbfd 100%);\r\n    transition: border-color 0.25s ease, transform 0.25s ease;\r\n\r\n    &:hover {\r\n      border-color: rgba(63, 185, 234, 0.5);\r\n      transform: translateY(-4px);\r\n    }\r\n\r\n    h3 {\r\n      margin: 0.9rem 0 0.3rem;\r\n      font-size: 1.15rem;\r\n      font-weight: 700;\r\n    }\r\n\r\n    h4 {\r\n      margin: 0 0 0.65rem;\r\n      font-size: 0.88rem;\r\n      font-weight: 600;\r\n      color: $home-teal-deep;\r\n      font-family: $home-body;\r\n      letter-spacing: 0;\r\n    }\r\n\r\n    p {\r\n      margin: 0;\r\n      color: $home-muted;\r\n      font-size: 0.95rem;\r\n      line-height: 1.55;\r\n    }\r\n  }\r\n\r\n  &__icon {\r\n    width: 48px;\r\n    height: 48px;\r\n    border-radius: 14px;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background: rgba(63, 185, 234, 0.14);\r\n    color: $home-teal-deep;\r\n    font-size: 1.15rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  .homePage .homeProducts {\r\n    &__tabs {\r\n      grid-template-columns: 1fr;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
